import { render, staticRenderFns } from "./ShowApprove.vue?vue&type=template&id=9951c6d2&"
import script from "./ShowApprove.vue?vue&type=script&lang=js&"
export * from "./ShowApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports